import { render, staticRenderFns } from "./forumPosts.vue?vue&type=template&id=7d46ff13&scoped=true"
import script from "./forumPosts.vue?vue&type=script&lang=js"
export * from "./forumPosts.vue?vue&type=script&lang=js"
import style0 from "./forumPosts.vue?vue&type=style&index=0&id=7d46ff13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d46ff13",
  null
  
)

export default component.exports